import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const deleteOrCancelMemberSlice = createSlice({
  name: 'deleteOrCancelMember',
  initialState,
  reducers: {
    deleteOrCancelMemberRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    deleteOrCancelMemberSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    deleteOrCancelMemberFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    deleteOrCancelMemberReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const deleteOrCancelMemberAction = deleteOrCancelMemberSlice.actions;
export default deleteOrCancelMemberSlice;